import React from 'react';

function fmtData(d) {
  const parts = String(d).slice(0, 10).split('-');
  if (parts.length !== 3) return '';
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

const CAT = { insumos: 'Insumos', contas: 'Contas', transporte: 'Transporte', embalagens: 'Embalagens', outros: 'Outros' };

export default function TabelaCustos({ custos, onDelete }) {
  if (custos.length === 0) return <div className="mt"><span className="mt-ico">🧾</span>Nenhum custo registrado.</div>;

  return (
    <div className="lst">
      {custos.map((c) => (
        <div key={c.id} className="it">
          <div className="it-main">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <strong style={{ fontSize: 14 }}>{c.descricao}</strong>
              <span className="bd bd-r">{CAT[c.categoria] || c.categoria}</span>
              <span style={{ fontSize: 11, color: 'var(--c4)' }}>{fmtData(c.data)}</span>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
            <strong style={{ fontSize: 15, color: 'var(--r)' }}>R$ {Number(c.valor).toFixed(2)}</strong>
            <button className="btn btn3 btn-sm" onClick={() => onDelete(c)}>x</button>
          </div>
        </div>
      ))}
    </div>
  );
}
